export default function description() {
    return (
        <div className="card__description-basic">
            <div className="card__description">
                <div className="card__description-title">Загальна характеристика</div>
                <p className="card__description-text">
                    СУПРЕМА — це сучасний гібрид соняшнику SUMO®, який поєднує стабільну врожайність, високу якість олії та відмінну адаптивність до різних умов вирощування. Гібрид створений для господарств, які прагнуть отримати надійний результат навіть у стресових умовах.
                </p>
                <p className="card__description-text">
                    Завдяки технології SUMO®, СУПРЕМА забезпечує ефективний контроль бур’янів та стабільну реалізацію потенціалу врожайності.
                </p>
                <ol className="card__description-list">
                    <p className="card__description-title">
                        Основні переваги:
                    </p>
                    <li className="card__description-numbering">Стабільна врожайність — до 5,0 т/га</li>
                    <li className="card__description-numbering">Висока посухостійкість</li>
                    <li className="card__description-numbering">Стійкість до вовчка — A–G</li>
                    <li className="card__description-numbering">Високий вміст олеїнової кислоти (преміальний сегмент)</li>
                    <li className="card__description-numbering">Потужна коренева система</li>
                    <li className="card__description-numbering">Швидкий стартовий ріст</li>
                </ol>
                <div className="card__description-title">Рекомендовані зони вирощування</div>
                <p className="card__description-text">
                    Гібрид підходить для вирощування у Степу, Лісостепу та Поліссі України, демонструючи стабільні результати в різних кліматичних умовах.
                </p>
                <ol className="card__description-list">
                    <p className="card__description-title">
                        Стійкість:
                    </p>
                    <li className="card__description-numbering">Енергія початкового росту — 9/10</li>
                    <li className="card__description-numbering">Посухостійкість — 9/10</li>
                    <li className="card__description-numbering">Стійкість до вилягання — 9/10</li>
                    <p className="card__description-title">
                        Додаткові переваги:
                    </p>
                    <li className="card__description-numbering">Висока стійкість до стресових факторів</li>
                    <li className="card__description-numbering">Стабільний результат навіть у посушливих умовах</li>
                    <li className="card__description-numbering">Висока рентабельність за рахунок якості олії</li>
                </ol>
                <div className="aside__title">Агрохімічні характеристики</div>
                <div className="aside__content">
                    <div className="aside-char--basic">
                        <div className="aside-char__head">Енергiя початкового росту</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--9">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">9</div>
                        </div>
                    </div>
                    <div className="aside-char--basic">
                        <div className="aside-char__head">Посухостiйкiсть</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--9">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">9</div>
                        </div>
                    </div>
                    <div className="aside-char--basic">
                        <div className="aside-char__head">Стiйкiсть до вилягання</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--9">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">9</div>
                        </div>
                    </div>
                </div>
                <p className="card__description-title">
                    Рекомендації щодо вирощування
                </p>
                <p className="card__description-text">
                    СУПРЕМА добре реагує на інтенсивні технології вирощування, але також показує стабільний результат при середньому агрофоні. Рекомендується застосування гербіцидів системи SUMO® для ефективного контролю бур’янів.
                </p>
                <p className="card__description-text">
                    Гібрид підходить як для інтенсивного, так і для помірного землеробства.
                </p>
            </div>
            <div className="card__description-preference">
                <div className="aside__title--new">Головні переваги</div>
                <div className="asede__head">
                    <div className="aside__block">Відмінна посухостійкість – стабільний результат навіть у стресових умовах</div>
                    <div className="aside__block">Швидкий стартовий ріст і потужна коренева система</div>
                    <div className="aside__block">Високий вміст олеїнової кислоти – преміальна ціна на ринку</div>
                </div>
            </div>
        </div>
    );
}
